import type { EmployeeDesignation } from '../types';
import { canAccessProjectPL } from './projectPLAccess';

/** PMs, EAs, and admins may approve a quote (and mark approved on upload). */
export function canApproveSupplierQuoteOnBehalf(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
  /** Project Hub timber project PM uid — allows approve/upload on that project's Suppliers tab. */
  hubProjectManagerUid?: string;
  userId?: string;
}): boolean {
  if (canAccessProjectPL(args)) return true;
  const pmUid = args.hubProjectManagerUid?.trim();
  const userId = args.userId?.trim();
  return !!(pmUid && userId && pmUid === userId);
}

/** PMs, EAs, admins, assigned hub PM, and field staff may upload supplier quote PDFs. */
export function canUploadSupplierQuoteOnBehalf(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
  /** Project Hub timber project PM uid — allows upload on that project's Suppliers tab. */
  hubProjectManagerUid?: string;
  userId?: string;
}): boolean {
  if (args.authRole === 'staff') return true;
  return canApproveSupplierQuoteOnBehalf(args);
}
